module.exports = __webpack_public_path__ + "static/media/7.c395f227.jpg";